<template>
  <div class="container-custom">
    <!-- Breadscrumbs -->
    <Breadscrumbs
      :links="[
        { name: 'Products', to: { path: '/products' } },
        { name: 'Product Info', to: { path: '/products/product-info' } },
        { name: 'Edit', to: { path: '/products/product-info/edit' } },
        {
          name: 'Edit Spec',
          to: { path: '/products/product-info/edit/edit-spec' },
        },
      ]"
    >
    </Breadscrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>編輯子分類</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">
        <span>取消</span>
      </button>
      <button class="btn btn-primary" @click="saveHandler">
        <span>儲存</span>
      </button>
    </div>
    <!-- Spec block -->
    <div class="d-flex">
      <!-- Title and description -->
      <div class="w-300px mr-5">
        <h3 class="mb-10px">Spec</h3>
        <div>
          Spec會顯示於產品頁、產品比較 <br />
          同SubCategory的產品將同步Spec欄位
        </div>
      </div>
      <!-- Spec Titles -->
      <div class="block flex-grow-1 flex-basis-0">
        <!-- add spec title -->
        <div class="d-flex pa-5 brand-100">
          <label for="filterTitleAdd"><h4 class="mr-5">Spec Title</h4></label>
          <div class="d-flex my-n2 flex-grow-1">
            <div class="form-input-group flex-grow-1">
              <input
                type="text"
                id="filterTitleAdd"
                placeholder="請輸入Spec標題"
                style="background: white;"
                v-model="tempSpecTitle"
              />
            </div>
            <div class="ml-5">
              <button class="btn btn-primary w-90px" @click="addItem">
                新增
              </button>
            </div>
          </div>
        </div>
        <!-- Spec Title -->
        <div
          class="form-item d-flex pa-5"
          v-for="(item, i) in specs"
          :key="item.id"
        >
          <label class="d-flex flex-grow-1">
            <h4 class="mr-5">Spec Title</h4>
            <div class="form-input-group flex-grow-1 my-n2">
              <input
                type="text"
                placeholder="請輸入Sec標題"
                style="background: white;"
                v-model="item.title"
              />
            </div>
          </label>
          <div class="ml-5 my-n2">
            <!-- <button class="btn square mr-10px" @click="deleteItem(item)">
              <v-icon>delete</v-icon>
            </button> -->
            <button class="btn square mr-10px" @click="downItem(item, i)">
              <v-icon>arrow_downward</v-icon>
            </button>
            <button class="btn square" @click="upItem(item, i)">
              <v-icon>arrow_upward</v-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';

export default {
  components: {
    Breadscrumbs,
  },
  data: () => ({
    tempSpecTitle: '',
  }),
  async created() {
    if (this.$route.params.id) {
      await this.getSubCategory(this.$route.params.id);
    }
  },
  computed: {
    ...mapState('subcategory', [
      'subcategory',
    ]),
    ...mapGetters('subcategory', [
      'specs',
    ]),
  },
  methods: {
    ...mapActions('subcategory', {
      setFilterData: 'setFilterData',
      toggleFilterDialog: 'toggleFilterDialog',
      getSubCategory: 'findById',
      saveSubCategory: 'save',
    }),
    addItem() {
      if (this.tempSpecTitle.trim() === '') {
        return;
      }

      const template = {
        id: null,
        title: this.tempSpecTitle.trim(),
        is_customized: 0,
        is_filter: 0,
      };

      this.subcategory.specs.push(template);
      this.tempSpecTitle = '';
    },
    deleteItem(item) {
      const index = this.subcategory.specs.map((option) => option.id).indexOf(item.id);
      this.subcategory.specs.splice(index, 1);
    },
    downItem(item, i) {
      // if i is last, then item become the first index
      if (i === this.subcategory.specs.length - 1) {
        this.subcategory.specs.splice(i, 1);
        this.subcategory.specs.unshift(item);
        return;
      }
      // item become next index
      this.subcategory.specs.splice(i, 1);
      this.subcategory.specs.splice(i + 1, 0, item);
    },
    upItem(item, i) {
      // if i = 0, then item go to the last one
      if (i === 0) {
        this.subcategory.specs.splice(i, 1);
        this.subcategory.specs.push(item);
        return;
      }
      // item become previous index
      this.subcategory.specs.splice(i, 1);
      this.subcategory.specs.splice(i - 1, 0, item);
    },
    cancelHandler() {
      this.$router.go(-1);
    },
    saveHandler() {
      const { getSubCategory, $router } = this;
      this.saveSubCategory(this.subcategory).then(() => {
        getSubCategory(this.subcategory.id);
        $router.go(-1);
      });
    },
  },
};
</script>

<style></style>
